import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBozvDAeAXUgTEzw9efIRjdamROXrXUKv8",
  authDomain: "portfolio-b1987.firebaseapp.com",
  projectId: "portfolio-b1987",
  storageBucket: "portfolio-b1987.firebasestorage.app",
  messagingSenderId: "208811860735",
  appId: "1:208811860735:web:1ceff637b114c5005762ca"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);